import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { ChapterType, getChapterIndex } from '../../../../../ui/src/common/book/BookHelpers';

const BookChapterCustom: React.FC<{
  chapter: any;
  chapters: any;
  index: number;
}> = ({ chapter, chapters, index }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const handleChangeChapter = () => {
    searchParams.delete('chapter');
    searchParams.set('chapter', chapter.id);
    setSearchParams(searchParams);
  };

  return (
    <div
      className={`chapter-detail ${
        chapter?.type === ChapterType.Review && 'chapter-review'
      }`}
      onClick={handleChangeChapter}>
      <div className="chapter-name">{chapter?.name}</div>
      <div className="chapter-index">
        {getChapterIndex(chapters, index, true)}
      </div>
      <div className="chapter-title">{chapter?.title}</div>
    </div>
  );
};

export default BookChapterCustom;
